<template>
  <p :class="['field',  editTime ? 'date_time_field' : '']">
    <label :for="id">
      <slot></slot>
    </label>
    <span class="datepicker_box">
        <input type="text" size="30" class="datepicker" autocomplete="off"
               ref="datePicker"
               :id="id"
               :name="id"
               :value="date"
               :date-format="dateFormat"
               @input="updateDate"
               :disabled="disabled"
        />
      <a class="clearable_btn"
         :style="getDeleteInputOptions"
         @click="resetOptions"
         title="Vymazat datum"><translate>Vymazat</translate></a>
                </span>
    <parental-lock-select-box
        v-if="editTime"
        :id="id + '_hours'"
        :options="hourOptions"
        :disabled="disabled"
        v-model="hour"
    ></parental-lock-select-box>
    <span v-if="editTime">:</span>
    <parental-lock-select-box
        v-if="editTime"
        :id="id + '_minutes'"
        :options="minuteOptions"
        :disabled="disabled"
        v-model="minutes"
    ></parental-lock-select-box>
  </p>
</template>

<script>
import datePicker from '@/components/mixins/date-picker'
import ParentalLockSelectBox from "@/components/common/ParentalLockSelectBox"
import {SET_LANGUAGE} from "../../store/mutation-types";

export default {
  name: "DatePicker",
  mixins: [datePicker],
  components: {ParentalLockSelectBox},
  props: {
    value: {
      type: String | Boolean,
      default: false
    },
    dateFormat: {
      type: String,
      default: 'yy-mm-dd'
    },
    editTime: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    perMinutes: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    date() {
      if (!this.value) return null;

      if (this.editTime) {
        const split = this.value.split(' ')
        return split.slice(0, split.length - 1).join(' ')
      } else {
        return this.value
      }
    },
    hour: {
      get: function () {
        if (!this.value) return null;
        const split = this.value.split(' ')
        if (split.length < 2 || split[split.length - 1].indexOf(':') == -1) return '00';

        return split[split.length - 1].split(':')[0]
      },
      set: function (hour) {
        this.time_hours = hour;
        this.updateDate({hour})
      }
    },
    minutes: {
      get: function () {
        if (!this.value) return null;
        const split = this.value.split(' ')
        if (split.length < 2 || split[split.length - 1].indexOf(':') == -1) return '00';

        var minutes = parseInt(split[split.length - 1].split(':')[1])
        if(minutes < 10){
          minutes = '0' + minutes;
        }

        if(!this.perMinutes) {
          minutes = (parseInt((minutes + 7.5) / 15) * 15) % 60
        }
        if (minutes === 0) minutes = '00';
        return minutes;
      },
      set: function (minutes) {
        this.time_minutes = minutes;
        this.updateDate({minutes})
      }
    },
    getDeleteInputOptions() {
      return !this.disabled && this.value ? 'display: block;' : 'display: none;';
    },
    minuteOptions() {
      if(this.perMinutes){
        let minutes = [];
        for(let i = 0; i < 60; i++){
          let value = i.toString();
          if(value.length === 1){
            value = '0'+value;
          }
          minutes.push({value: value, text: value});
        }
        return minutes;
      }else{
        return [
          {value: '00', text: '00'},
          {value: '15', text: '15'},
          {value: '30', text: '30'},
          {value: '45', text: '45'},
        ]
      }
    },
    hourOptions() {
      let options = []
      for (let i = 0; i < 24; i++) {
        let hourValue = String(i)
        if (i < 10) {
          hourValue = '0' + hourValue
        }
        let option = {value: hourValue, text: hourValue}
        options.push(option)
      }
      return options
    },
  },
  data: function () {
    return {
      time_minutes: null,
      time_hours: null,
    }
  },
  methods: {
    resetOptions() {
      this.value = null;
      this.$emit('update-date', {date: null, attrKey: this.attrKey})
    },
    emitUpdateDateEvent(date) {
      // Override date-picker mixin event
      this.updateDate({date})
    },
    updateDate({date = this.$refs.datePicker.value, hour = this.hour, minutes = this.minutes}) {
      if (date === null || date === '') {
        this.$emit('update-date', {date: null, attrKey: this.attrKey})
        return
      } else if (this.editTime) {
        date += ` ${this.time_hours || '00'}:${this.time_minutes || '00'}`
      }
      this.$emit('update-date', {date: date, attrKey: this.attrKey})
    }
  },
  watch: {
    value(value){
      this.time_minutes = this.minutes;
      this.time_hours = this.hour;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/DatePicker.vue